import { IConfigs, useScopedReducer } from 'src/shef-global-state/shefGlobalState';

export const useFeatureFlag = (featureFlagName: keyof IConfigs) => {
  const { state: configs } = useScopedReducer('configs');
  return Boolean(configs[featureFlagName]);
};
